import React from 'react';

const PageTransition = ({ children }) => {
  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 ease-in-out">
      {children}
    </div>
  );
};

export default PageTransition;
